import { COUNTRY_CODES } from "@/constants/CountryOptions";
import { AD_SUBURB_SCHEMA } from "@/sell/models/AdSuburb";
import { z } from "zod";

const INSURANCE_AGES = ["05", "10", "15", "20"] as const;

export type InsuranceAge = (typeof INSURANCE_AGES)[number];

export const INSURANCE_AGE_OPTIONS: {
  label: string;
  value: (typeof INSURANCE_AGES)[number];
  maxYearsOld: number;
}[] = [
  {
    label: "5 years and under",
    value: "05",
    maxYearsOld: 5,
  },
  {
    label: "6 to 9 years",
    value: "10",
    maxYearsOld: 9,
  },
  {
    label: "10 to 15 years",
    value: "15",
    maxYearsOld: 15,
  },
  {
    label: "16 years and over",
    value: "20",
    maxYearsOld: 100,
  },
];

export const INSURANCE_CASE_SOURCE = ['AD_ESTIMATE', 'AD_ENQUIRY', 'LANDING_PAGE'] as const;

export type InsuranceCaseSource = (typeof INSURANCE_CASE_SOURCE)[number];

export const CREATE_INSURANCE_CASE_VIEW_MODEL_SCHEMA = z.object({
  key: z.string(),
  name: z.string().min(1, "Name is required"),
  phone: z.string().min(1, "Phone is required"),
  email: z.string().min(1, "Email is required"),
  ageOfHorse: z
    .enum(INSURANCE_AGES)
    .or(z.literal(""))
    .refine((val) => val !== "", {
      message: "Age of horse is required",
    }),
  countryCode: z.enum(COUNTRY_CODES, "Country is required"),
  suburb: AD_SUBURB_SCHEMA,
  source: z.enum(INSURANCE_CASE_SOURCE, "Source is required"),
});

export type CreateInsuranceCaseViewModel = z.infer<
  typeof CREATE_INSURANCE_CASE_VIEW_MODEL_SCHEMA
>;
